import { render } from "./regalos.vue?vue&type=template&id=dd63c16e&scoped=true"
import script from "./regalos.vue?vue&type=script&lang=js"
export * from "./regalos.vue?vue&type=script&lang=js"

import "./regalos.vue?vue&type=style&index=0&id=dd63c16e&scoped=true&lang=css"
import "./regalos.vue?vue&type=style&index=1&id=dd63c16e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd63c16e"]])

export default __exports__